// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"945":"7c13cb0c","4006":"a620c647"}[chunkId] + ".chunk.css";
};